<template>

  <el-form :inline="true" label-position="top">

    <date-input label="Started" v-model="equip.rentStarted" placeholder="Rent From" :disabled="!this.isEdit" />
    <select-frequency v-model="equip.billPeriod"  :disabled="!this.isEdit" />

    <check-box  label="Invoice?" v-model="equip.isInvoiceItem"  :disabled="!this.isEdit">Invoice Item</check-box>

    <text-input label="Ref No." v-model="equip.refNo" placeholder="Ref. No." :disabled="!this.isEdit" />

    <el-row>
      <currency-input v-model="equip.amount" :disabled="!this.isEdit" />

      <check-box label="Taxable" v-model="isTaxable" placeholder="Taxable" :disabled="!this.isEdit" />

      <currency-input v-if="isTaxable" :label="'Tax = ' + taxDue(equip.amount)" v-model="equip.tax" placeholder="Tax" :disabled="!this.isEdit" />
      <el-form-item v-else label="Tax">
        <b v-if="equip.tax">{{formatNumber(this.tax)}}</b>
      </el-form-item>

<!--      <currency-input v-if="isTaxable" type="number" label="Total" v-model="equip.total" placeholder="Total" :disabled="!this.isEdit" /> -->
      <el-form-item label="Total">
        <b>{{formatNumber(this.total)}}</b>
      </el-form-item>
    </el-row>

    <el-row>
      <h4>Deposit &amp; Advance Fees</h4>
    </el-row>

    <el-row>
      <el-col class="deposit-pane" :sm="24" :md="24" :lg="16">

        <el-row>
          <check-box v-if="showDepCheck" v-model="hasDesposit" :disabled="!this.isEdit">Has Deposit?</check-box>
            <b v-else class="text-muted">Deposit</b>
        </el-row>

        <float-input v-if="hasDesposit" label="Amount" v-model="equip.deposit" placeholder="Amount" :disabled="!this.isEdit" />
        <date-input  v-if="hasDesposit" label="Deposit Date" v-model="equip.depositDate" placeholder="Date" :disabled="!this.isEdit" />
        <text-input  v-if="hasDesposit" label="Deposit Ref" v-model="equip.depositRef" placeholder="Deposit Ref" :disabled="!this.isEdit" />

      </el-col>

      <el-col class="advance-pane" :sm="24" :md="24" :lg="6">

        <el-row>
          <check-box  v-if="!equip.advanceFee" v-model="isAdvance" :disabled="!this.isEdit">Has Advance Fees?</check-box>
            <b class="text-muted" v-else>Advance Fees</b>
        </el-row>

        <float-input v-if="isAdvance" label="Amount" v-model="equip.advanceFee" placeholder="Amount" :disabled="!this.isEdit" />
      </el-col>

    </el-row>

    <el-row>
      <h4>Purchase Cost</h4>
    </el-row>

    <el-row>
      <currency-input v-model="equip.purchaseCost" :disabled="!this.isEdit" />
      <currency-input  :label="'Tax = ' + taxDue(equip.purchaseCost)" v-model="equip.purchaseTax" placeholder="Tax" :disabled="!this.isEdit" />

<!--      <currency-input v-if="isTaxable" type="number" label="Total" v-model="equip.total" placeholder="Total" :disabled="!this.isEdit" /> -->
      <el-form-item v-if="equip.purchaseCost && equip.purchaseTax" label="Total">
        <b>{{formatNumber(equip.purchaseCost + equip.purchaseTax)}}</b>
      </el-form-item>
    </el-row>

  </el-form>

</template>


<script>
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

export default {
  mixins: [DateMixins, NumberMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    tax: function () {

      if (this.isTaxable) {
        this.equip.tax = this.taxDue(this.equip.amount, this.isTaxable)
      }

      return this.equip.tax
    },

    total: function () {
      this.equip.total = this.totalDue(this.equip.amount, this.equip.tax)
      return this.equip.total
    }

  },

  data () {
    return {
      showDepCheck: (Number(this.rowData.deposit) <= 0),
      hasDesposit: (Number(this.rowData.deposit) > 0),
      isAdvance: (Number(this.rowData.advanceFee) > 0),
      isTaxable: this.showTax(),
      equip: this.rowData
    }
  }
}
</script>


<style scoped>
 .deposit-pane {
   background: rgb(242,246,252, 0.3);
   padding: 0.5rem;
   margin: 0.5rem;
   border-radius: 5px;
 }

 .advance-pane {
   background: rgb(103,194,58, 0.08);
   padding: 0.5rem;
   margin: 0.5rem;
   border-radius: 5px;
 }

</style>
